import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';

import Headline from './Headline';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const Headlines = ({ stepDuration, delay, headlines, hasFetched, lastUpdated }) => {
  const variants = {
    hidden: i => ({
      opacity: 0,
      y: (i + 1) * -5,
      x: 0,
    }),
    visible: i => ({
      opacity: 1,
      x: 0,
      y: 0,
      transition: { delay: i * ((stepDuration - 100) / 1000) + (delay / 1000) + 0.2 },
    }),
  };

  const controls = useAnimation();

  useEffect(() => {
    if (!hasFetched) return;
    controls.start('visible');
  }, [controls, hasFetched]);

  const Headlines = headlines.map((hed, i) => (
    <motion.div
      custom={i}
      animate={controls}
      variants={variants}
      initial='hidden'
      key={hed.smartText.context.country + i}
    >
      <Headline {...hed} key={hed.smartText.context.country} />
    </motion.div>
  ));

  return (
    <div className={classnames('headlines', component)}>
      {Headlines}
    </div>
  );
};

export default Headlines;
